module.exports = __webpack_public_path__ + "img/grey-red-line.23fdb306.svg";